import { Box } from '@mui/material';

import { ContrastedText } from './ContrastedText';

import type { ContrastedTextProps } from './ContrastedText';
import type { BoxProps } from '@mui/material';
import type { FC } from 'react';

export interface SiteTitleProps extends Omit<ContrastedTextProps, keyof BoxProps>, BoxProps {}

export const SiteTitle: FC<SiteTitleProps> = ({ children, fontWeight, ...props }) => (
  <Box display="flex" height="auto" alignItems="center" component="span" {...props}>
    <ContrastedText fontWeight={fontWeight} component="p" variant="h5">
      {children}
    </ContrastedText>
  </Box>
);
